import React, { useState, useEffect } from 'react';
import get from 'lodash/get';
import cn from 'classnames';
import { validateForm, scrollToErrorField } from 'utils/form';
import Form, { useForm } from 'components/Form';
import HeaderActions from 'views/pages/ClientDetail/CompanyOfficial/components/HeaderActions';
import OtherIntegrateSection from 'views/pages/ClientDetail/components/OtherIntegrateSection';
import {
  getValidateArray,
  updateAccountCardIds,
} from 'views/pages/ClientDetail/Driver/components/Section/utils';
import { useIsInternalUser } from 'helper/hooks';
import Profile from './Profile';
import Contact from './Contact';
import Address from './Address';
import CheckingAccount from './CheckingAccount';
import FuelCard from './FuelCard';
import { validateObj, getInitialValues } from '../../utils';
import classes from './Section.module.scss';

const Section = ({
  className,
  isActive,
  isEdit,
  setIsEdit,
  onFormChange,
  openWarningModal,
  rootKey,
  data,
  onSubmit,
  onStatusChange,
  statusLoading,
  loading,
  onEditCheckingAccount,
  onValidatePassword,
  validatePasswordLoading,
  getLeasorAccountLoading,
  onEditFuelCard,
  getFuelCardLoading,
  isNew,
  clientId,
}) => {
  const { isInternalUser } = useIsInternalUser();
  const accountsData = data.accounts || [];
  const cardsData = data.cards || [];
  const wrapperId = `leasor_information_${rootKey}`;
  const [isFormChange, setIsFormChanged] = useState(false);
  const [form] = useForm();
  const handleSubmit = values => {
    const fieldSingleErrors = validateForm(validateObj(), values);
    const fieldArrayErrors = validateForm(
      getValidateArray(values),
      values,
      true
    );
    if (fieldSingleErrors.length > 0 || fieldArrayErrors.length > 0) {
      form.setFields([...fieldSingleErrors, ...fieldArrayErrors]);
      scrollToErrorField(wrapperId);
    } else {
      onSubmit(values, res => {
        const newAccounts = get(res, 'data.payment_accounts') || [];
        const newCards = get(res, 'data.fuel_cards') || [];
        if (newAccounts.length > 0 || newCards.length > 0) {
          updateAccountCardIds(form, newAccounts, newCards);
        }
        setIsEdit(false);
      });
    }
  };

  useEffect(() => {
    if (isEdit) {
      setIsFormChanged(false);
      if (form) {
        form.resetFields();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEdit]);
  useEffect(() => {
    if (form && isActive) {
      updateAccountCardIds(form, accountsData, cardsData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isActive]);

  return (
    <div className={cn(classes.wrapper, className)} id={wrapperId}>
      <Form
        validateMessages={''}
        onFinish={handleSubmit}
        initialValues={getInitialValues(data, isInternalUser)}
        form={form}
        onValuesChange={() => {
          setIsFormChanged(true);
          onFormChange();
        }}
      >
        {isActive && (
          <HeaderActions
            className={classes.headerActions}
            isEdit={isEdit}
            setIsEdit={setIsEdit}
            form={form}
            isFormChange={isFormChange}
            loading={loading}
            handleSubmit={handleSubmit}
            openWarningModal={openWarningModal}
            status={data?.status}
            onStatusChange={onStatusChange}
            statusLoading={statusLoading}
            inSection
          />
        )}
        <Profile
          isEdit={isEdit}
          form={form}
          data={data}
          isNew={isNew}
          clientId={clientId}
        />
        <Address isEdit={isEdit} form={form} data={data} />
        <Contact isEdit={isEdit} form={form} data={data} />
        <CheckingAccount
          isEdit={isEdit}
          form={form}
          accounts={accountsData}
          onEdit={onEditCheckingAccount}
          onValidatePassword={onValidatePassword('accounts')}
          validatePasswordLoading={validatePasswordLoading}
          getLeasorAccountLoading={getLeasorAccountLoading}
          wrapperId={wrapperId}
        />
        <FuelCard
          isEdit={isEdit}
          form={form}
          cards={cardsData}
          onEdit={onEditFuelCard}
          onValidatePassword={onValidatePassword('fuel_cards')}
          validatePasswordLoading={validatePasswordLoading}
          getFuelCardLoading={getFuelCardLoading}
          wrapperId={wrapperId}
        />
        <OtherIntegrateSection
          isEdit={isEdit}
          form={form}
          other={data.custom_fields || []}
          otherName="custom_fields"
        />
      </Form>
    </div>
  );
};

export default Section;
